module.exports = __webpack_public_path__ + "img/CFL.c5d170ee.png";